
import type { IconProps } from 'src/types/icons';

const AccordionIcon = (props: IconProps) => (
  <svg {...props} width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M7.31248 6.86783C7.32874 7.07006 7.25951 7.27788 7.10481 7.43258L1.55598 12.9814C1.27598 13.2614 0.822022 13.2614 0.542027 12.9814C0.262033 12.7014 0.262033 12.2475 0.542028 11.9675L5.64166 6.86783L0.542028 1.7682C0.262033 1.48821 0.262032 1.03425 0.542027 0.754252C0.822022 0.474257 1.27598 0.474257 1.55598 0.754252L7.10481 6.30308C7.25951 6.45778 7.32874 6.6656 7.31248 6.86783Z" fill="black" />
  </svg>
);
export default AccordionIcon;
